import AlgonomyAnalytic from '@package/services/src/Algonomy/services/AlgonomyAnalytic';
import ApiClient from '@package/services/src/ApiClient';
import ListrakAnalytic from '@package/services/src/ListrakAnalytic';
import NeedleAnalytic from '@package/services/src/Needle';
import CookieStorage from '@package/services/src/Storage/Cookie';
import StorageManager from '@package/services/src/Storage/StorageManager';
import config from 'config-base';

export const apiClient = new ApiClient(config.apiClientSideUrl, config.apiServerSideUrl);
export const storageManager = new StorageManager(config.storageKey);
export const cookieStorage = new CookieStorage();
export const needleAnalytic = new NeedleAnalytic();
export const listrakAnalytic = new ListrakAnalytic(apiClient, cookieStorage);

export const algonomyAnalytic = new AlgonomyAnalytic(apiClient);
